import { NavLink } from "react-router";

import Badge from "components/badge/Badge";
import { SubMenuItemType } from "views/layout/components/CustomerSubmenu";
import { useGlobalContext } from "app/store/GlobalContext";

import "./Submenu.scss";

interface Props {
  item: SubMenuItemType;
  children: string;
}

export const SubMenuItem = ({ item, children }: Props) => {
  const { handleNavigation } = useGlobalContext();

  return (
    <li title={item.text}>
      <NavLink
        className={({ isActive }) =>
          `link ${item.disabled ? "disabled" : ""} ${!item.disabled && isActive ? "linkActive" : ""}`
        }
        to={item.href}
        onClick={(e) => handleNavigation({url: item.href, eventTitle: item.title, e: e})}
      >
        {children}
        {typeof item.count === "number" && item.count > 0 && (
          <Badge className="badge" count={item.count} />
        )}
        {item.notice && <Badge className="badge" notice={item.notice} />}
      </NavLink>
    </li>
  );
};
